@if (history) {
	<div class="row margin-left-sm margin-bottom-lg" [attr.data-test-id]="'rapidReviewRfv'">
		<div class="col-lg-6">
			<div><strong>Patient RFV</strong></div>
			<div class="white-space-pre-wrap">{{ history.reasonForVisit?.patientReason ?? 'No data to display' }}</div>
		</div>
		<div class="col-lg-6">
			<div><strong>Provider RFV</strong></div>
			<div class="mrgn-btm white-space-pre-wrap">{{ history.reasonForVisit?.providerReason ?? 'No data to display' }}</div>
			<div><strong>Medical Reason:</strong> {{ history.reasonForVisit?.isMedicalReason | yesNo }}</div>
		</div>
	</div>
	<h4 class="section-title bg-default mrgn-btm">Past Dx/CPI</h4>
	<div class="margin-left-sm margin-bottom-lg">
		@for (diagnosis of history.reasonForVisit?.historyDiagnoses; track diagnosis) {
			<pms-rapid-review-diagnosis [diagnosis]="diagnosis"></pms-rapid-review-diagnosis>
		} @empty {
			No data to display
			<hr>
		}
		@if (history.formattedPresentIllnesses) {
			<p [attr.data-test-id]="'rapidReviewHpi'"><strong>History of Present Illness (HPI):</strong> {{ history.formattedPresentIllnesses }}</p>
		}
		@if (history.formattedReviewOfSystems) {
			<p [attr.data-test-id]="'rapidReviewRos'"><strong>Review of Systems (ROS):</strong> {{ history.formattedReviewOfSystems }}</p>
		}
		@if (history.formattedMedications) {
			<p [attr.data-test-id]="'rapidReviewMeds'"><strong>Medications:</strong> {{ history.formattedMedications }}</p>
		}
		@if (history.formattedAllergies) {
			<p [attr.data-test-id]="'rapidReviewAllergies'"><strong>Allergies:</strong> {{ history.formattedAllergies }}</p>
		}
		@if (history.formattedOcularHistory) {
			<p [attr.data-test-id]="'rapidReviewOcularHistory'"><strong>Ocular History:</strong> {{ history.formattedOcularHistory }}</p>
		}
		@if (history.formattedFamilyHistory) {
			<p [attr.data-test-id]="'rapidReviewFamilyHistory'"><strong>Family History:</strong> {{ history.formattedFamilyHistory }}</p>
		}
	</div>
	<h4 class="section-title bg-default mrgn-btm">VAs</h4>
	<div class="margin-left-sm" [attr.data-test-id]="'rapidReviewVas'">
		@if (history.formattedAcuityFields.length > 0) {
			<div class="mrgn-btm">
				<ag-grid-angular
					class="ag-theme-alpine ag-grid-compact"
					pmsAgAutoFitColumns
					[rowData]="history.formattedAcuityFields"
					[columnDefs]="gridColumns"
					[pagination]="false">
				</ag-grid-angular>
			</div>
		} @else {
			<p class="margin-bottom-lg">No data to display</p>
		}
	</div>
}
<ng-template #visualAcuityTemplate let-params="params">
	@if (params.value; as acuity) {
		@if (acuity.value) {
			{{ acuity.value }}
		}
		@if (acuity.od) {
			<span class="badge text-bg-success margin-right-sm">OD</span>{{ acuity.od }}
		}
		@if (acuity.os) {
			<span class="badge text-bg-info margin-y-sm">OS</span>{{ acuity.os }}
		}
		@if (acuity.ou) {
			<span class="badge text-bg-default margin-y-sm">OU</span>{{ acuity.ou }}
		}
	}
</ng-template>
